import { render, staticRenderFns } from "./companyaccountmain-add-or-update.vue?vue&type=template&id=1fbb0d9b&"
import script from "./companyaccountmain-add-or-update.vue?vue&type=script&lang=js&"
export * from "./companyaccountmain-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports